const AbiEntrySummaryApiUrls = {
  GET: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/ui/get`,
  POST: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/create`,
  PUT: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/update`,
  DELETE: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/delete`,
  DELETE_ALL: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/deleteAll`,
  TEST: `${process.env.REACT_APP_USER_ABI_URL}/abi/test`,
  GET_ENTRY_LIST: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/entrylist/get`,
  SAVE_ALL: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/save-all`,
  UPLOAD_LINE_ITEMS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/line-items/upload`,
  GET_LINE_ITEMS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/line-items/get`,
  CALCULATE_LINE_ITEMS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/line-items/calculate`,
  CALCULATE_ALL_DUTY_LINE_ITEMS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/line-items/calculate-all-duty`,
  SAVE_LINE_ITEM: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/line-items/save`,
  DELETE_LINE_ITEMS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/line-items/delete`,
  CLONE_LINE_ITEM: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/line-items/clone`,
  DOWNLOAD_LINE_ITEMS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/line-items/download`,
  DELETE_ALL_LINE_ITEMS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/line-items/deleteAll`,
  DUTY_CALCULATE_LINE_ITEMS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/line-items/calculate-duty`,
  GET_FILE_UPLOAD: `${process.env.REACT_APP_USER_ABI_URL}/abi/file-upload/get`,
  SUBMIT: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/submit`,
  SUBMIT_PGA_CORRECTION: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/submit-pga-correction`,
  CLONE: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/clone`,
  DOWNLOAD_FORM_7501: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/form-7501/download`,
  DOWNLOAD_FORM_3461: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/form-3461/download`,
  GET_FORM_7501_PRINT_OPTIONS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/form-7501/print-options/get`,
  GET_FORM_3461_PRINT_OPTIONS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/form-3461/print-options/get`,
  GET_HTS_CODE: `${process.env.REACT_APP_USER_ABI_URL}/abi/hts-code/get`,
  LIST_HTS_CODE: `${process.env.REACT_APP_USER_ABI_URL}/abi/hts-code/list`,
  EDIT_HTS_CODE: `${process.env.REACT_APP_USER_ABI_URL}/abi/hts-code/edit`,
  DELETE_HTS_CODE: `${process.env.REACT_APP_USER_ABI_URL}/abi/hts-code/delete`,
  UPLOAD_HTS_CODE: `${process.env.REACT_APP_USER_ABI_URL}/abi/hts-code/upload`,
  GET_PGA_FLAG_CODE: `${process.env.REACT_APP_USER_ABI_URL}/abi/pga-flag-code/get`,
  LIST_PGA_FLAG_CODE: `${process.env.REACT_APP_USER_ABI_URL}/abi/pga-flag-code/list`,
  EDIT_PGA_FLAG_CODE: `${process.env.REACT_APP_USER_ABI_URL}/abi/pga-flag-code/edit`,
  DELETE_PGA_FLAG_CODE: `${process.env.REACT_APP_USER_ABI_URL}/abi/pga-flag-code/delete`,
  UPLOAD_PGA_FLAG_CODE: `${process.env.REACT_APP_USER_ABI_URL}/abi/pga-flag-code/upload`,
  QUERY: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/query`,
  GET_DIS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/dis/get`,
  UPLOAD_DIS: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/dis/upload`,
  DOWNLOAD_DIS_FILE: `${process.env.REACT_APP_USER_ABI_URL}/abi/entry-summary/dis/download`
};

export default AbiEntrySummaryApiUrls
